

<footer class="main-footer">
    <!-- To the right -->
    <div class="float-right d-none d-sm-inline">
    Yavé 
    </div>
    <!-- Default to the left -->
    <strong>Copyright &copy; 2024.</strong> Todos los derechos reservados.
  </footer>
  <!-- ./wrapper -->
  
  <!-- REQUIRED SCRIPTS -->
  
  <!-- jQuery -->







  
  



